import _ from 'lodash';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class BasketRaffleService {

  constructor(
    private http: HttpClient,
    private cookieService: CookieService
  ) { }

  getBasketRaffleItemList(campaignId) {
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify({ campaignId }))}`
    ];
    return this.http.post('/api/ticket/basket/items/get', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  createBasketRaffleItem(campaignId, basketItem) {
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify({ campaignId, basketItem }))}`
    ];
    return this.http.post('/api/ticket/basket/item/add', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  updateBasketRaffleItem(campaignId, basketItem) {
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify({ campaignId, basketItem }))}`
    ];
    return this.http.post('/api/ticket/basket/item/update', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  updateBasketRaffleItemList(campaignId, basketItems) {
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify({ campaignId, basketItems }))}`
    ];
    return this.http.post('/api/ticket/basket/items/update', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  deleteBasketRaffleItem(campaignId, basketItemId) {
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify({ campaignId, basketItemId }))}`
    ];
    return this.http.post('/api/ticket/basket/item/delete', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

}
